import installServiceImpl from '../install-service';
import type { InstallService } from './contracts';

export type { InstallService } from './contracts';
export const installService: InstallService = installServiceImpl;
